import { cn } from "@/lib/utils";
import { Link, useNavigate } from "@tanstack/react-router";
import { ArrowLeftRight, PieChart, Plus, Search, Settings } from "lucide-react";

const activeBtnStyle =
  "footer-button-shadow transition-all duration-150 block rounded-full border-2 border-emerald-800 bg-emerald-50 p-[14px] text-emerald-900";
const inactiveBtnStyle =
  "block rounded-full border-2 transition-all duration-150 border-neutral-200 bg-white p-[14px] text-neutral-600";

export const OverviewFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="fixed inset-x-0 bottom-0 z-30 bg-gradient-to-t from-neutral-100 to-transparent pb-7">
      <nav>
        <ul className="flex items-center justify-center space-x-2">
          <li>
            <Link
              search={{ category: undefined }}
              className="block"
              aria-label="Overview"
              data-attr="menu-overview"
              to="/overview"
              href="/overview"
              tabIndex={0}
            >
              {({ isActive }) => (
                <span className={isActive ? activeBtnStyle : inactiveBtnStyle}>
                  <PieChart size={20} />
                </span>
              )}
            </Link>
          </li>
          <li>
            <Link tabIndex={0} className="block" aria-label="Recent" data-attr="menu-recent" to="/" href="/">
              {({ isActive }) => (
                <span className={isActive ? activeBtnStyle : inactiveBtnStyle}>
                  <ArrowLeftRight size={20} />
                </span>
              )}
            </Link>
          </li>
          <li className="footer-button-shadow px-2">
            <Link
              aria-label="Tambah pengeluaran"
              to="/pengeluaran"
              href="/pengeluaran"
              data-attr="add-transaction"
              tabIndex={0}
              onKeyDown={function (event) {
                if (event.code === "Space" || event.code === "Enter") {
                  navigate({ to: "/pengeluaran" });
                }
              }}
              className={cn([
                "block flex-1 cursor-pointer rounded-full bg-emerald-950 p-4 text-emerald-50 transition duration-100",
                "hover:bg-emerald-900 focus-visible:bg-emerald-900 focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-opacity-50 focus-visible:ring-offset-2 focus-visible:ring-offset-emerald-500",
              ])}
            >
              <Plus size={32} />
            </Link>
          </li>
          <li>
            <Link
              search={{ error: undefined }}
              disabled
              className="block"
              aria-label="Pencarian"
              data-attr="menu-search"
              to="/pengaturan"
              href="/pengaturan"
            >
              {({ isActive }) => (
                <span className={cn(isActive ? inactiveBtnStyle : inactiveBtnStyle, "border-neutral-100 text-neutral-200")}>
                  <Search size={20} />
                </span>
              )}
            </Link>
          </li>
          <li>
            <Link
              search={{ error: undefined }}
              className="block"
              aria-label="Pengaturan"
              data-attr="menu-settings"
              to="/pengaturan"
              href="/pengaturan"
              tabIndex={0}
            >
              {({ isActive }) => (
                <span className={isActive ? activeBtnStyle : inactiveBtnStyle}>
                  <Settings size={20} />
                </span>
              )}
            </Link>
          </li>
        </ul>
      </nav>
    </footer>
  );
};
